export class ProductDetail {
    constructor(data = null) {
        if (data) {
            this.id = data?.id || '';
            this.identifier = data?.identifier || '';
            this.fullname = data?.fullname || '';
            this.sku = data?.sku || '';
            this.multidimensional = data?.multidimensional || false;
            this.isKitProduct = data?.isKitProduct || false;
            this.infoTags = data?.infoTags || [];
            this.galleryImages = data?.galleryImages || [];
            this.thumbnailImages = data?.thumbnailImages || [];
            this.prices = data?.prices || [];
            this.description = data?.description || '';
            this.stock = data?.stock || {};
            this.paymentOptions = data?.paymentOptions || [];
            this.baseOptions = data?.baseOptions || [];
            this.type = data?.type || '';
            this.amwayValue = data?.amwayValue || {};
            this.kitEntries = data?.kitEntries || [];
            this.categories = data?.categories || [];
            this.isEligibleForMyList = data?.isEligibleForMyList || false;
            this.hasAStarter = data?.hasAStarter || false;
            this.amwayAPointOptions = data?.amwayAPointOptions || [];
            this.customerSelling = data?.customerSelling || false;
            this.remainingCoupons = data?.remainingCoupons || 0;
            this.redeemCondition = data?.redeemCondition || '';
        }
    }
}